import React from 'react';
import { CircularProgress, IconButton } from '@mui/material';
import Tooltip, { DefaultTooltipPopperProps } from 'js/components/elements/mui/Tooltip';
import { Refresh as RefreshIcon } from '@mui/icons-material';

const minStyle = { width: 36, height: 36 };
export function RefreshIconButton({ isLoading, onRefreshClicked }) {
  if (isLoading) {
    return (
      <IconButton disabled style={minStyle}>
        <CircularProgress size={16} />
      </IconButton>
    );
  }

  return (
    // @ts-ignore
    <Tooltip
      title="Refresh"
      arrow
      placement="top"
      interactive="true"
      tooltipTheme="dark"
      PopperPros={DefaultTooltipPopperProps}
    >
      <IconButton onClick={onRefreshClicked}>
        <RefreshIcon fontSize="large" />
      </IconButton>
    </Tooltip>
  );
}
